import { useState } from 'react';
import { faDiagramProject } from '@fortawesome/pro-solid-svg-icons';

import { AsyncFunction, ModalProps } from '@typings';
import { deleteFlow } from '@services';
import { noop, noopAsync, toastifyResponseError } from '@utils';

import { Button, Icon, Modal } from '@components';

type Props = ModalProps & {
  name: string;
  projectId: string;
  getFlows?: AsyncFunction;
};

export const DeleteFlowModal = ({
  name,
  projectId,
  getFlows = noopAsync,
  closeModal = noop,
}: Props) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);

    try {
      await deleteFlow(projectId);
      await getFlows();

      closeModal();
    } catch (error) {
      toastifyResponseError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal.Content title="Delete Flow" className="w-[520px]">
      <p className="flex flex-wrap items-center text-neural-03">
        Are you sure you want to delete
        <span className="space-both inline-flex items-center gap-1 text-body text-black">
          <Icon icon={faDiagramProject} className="h-4 w-4 text-[14px]" />
          {name}
        </span>
        flow? This operation deletes all information about the live jobs, the
        bakes, and the caches. The flow files are not removed
      </p>

      <Modal.Footer>
        <Button variant="ghost" onClick={closeModal}>
          Cancel
        </Button>
        <Button loading={loading} className="px-14" onClick={handleDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal.Content>
  );
};
